export const COUNTRIES_WITH_GEOLOCATION_INFO = new Set(['AR', 'BR', 'MX']);
